import { create } from 'zustand';

const useStoreGarmentStock = create((set) => ({  
  schedularDate: {},
  setSchedularDate: (val) => set({ schedularDate: val }),
   
}));
export default useStoreGarmentStock;
